//=> https://developers.google.com/analytics/devguides/collection/ga4/reference/events#search

class ProductSearchEventListener {
    // Language: javascript
    // Path: ProductSearchEventListener.js
    // Compare this snippet from EventListener.js:

    get ProductSearchButton() {
        return ".gtm-search-button";
    }
    get ProductSearchText() {
        return ".gtm-searchkey";
    }
    get DefaultEventName() {
        return "click";
    }

    constructor(element, eventName = this.DefaultEventName) {
        this.element = element;
        this.eventName = eventName;
    }
    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();

        var search_key = document.querySelector(
            ProductSearchEventListener.prototype.ProductSearchText
        ).value;
        dataLayer
            .push({
                // eslint-disable-line
                event: "search",
                search_term: search_key,
            })
            .then(() => {
                console.log("GTM pushed search event");
            })
            .catch((error) => {
                console.warn("GTM error search event", error);
            });

        if (typeof gtag !== "undefined" && !!gtag) {
            gtag("event", "search", {
                event_category: "Enhanced Ecommerce",
                event_label: "search",
                search_term: search_key,
            });
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            ProductSearchEventListener.prototype.callback
        );
    }

    remove() {
        this.element.removeEventListener(this.eventName, this.callback);
    }
}
